import React, { Fragment } from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    invoiceNoContainer: {
        flexDirection: 'row',
        marginTop: 36,
        justifyContent: 'flex-end'
    },
    invoiceDateContainer: {
        flexDirection: 'column',
        // justifyContent: 'flex-end',
        position: 'absolute',
        right: 0,
    },
    invoiceDate: {
            fontSize: 12,
            fontStyle: 'bold',
    },
    label: {
        width: 100,
        color: '#c00000',
        textDecoration: 'underline',
        // textDecorationColor: '#404040',
        marginBottom: 10,
    }
    
  });


  const InvoiceNo = ({invoice}) => (
        <Fragment>
            <View style={styles.invoiceDateContainer}>
                {/* <Text style={styles.label}>INVOICE DATE</Text> */}
                <Text style={styles.label}>RECEPIT DATE</Text>
                <Text >{invoice.from_date}</Text>
            </View >
        </Fragment>
  );
  
  export default InvoiceNo